
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const VI_SUCCESS = "VI_SUCCESS";
export const VI_FAIL = "VI_FAIL";

export const LANG_CHANGE_SUCCESS = "LANG_CHANGE_SUCCESS";
export const LANG_CHANGE_FAIL = "LANG_CHANGE_FAIL";


export const TERMS_ACCEPTED = "TERMS_ACCEPTED";
export const TERMS_NOT_ACCEPTED = "TERMS_NOT_ACCEPTED";
export const TERMS_OPENED = "TERMS_OPEN";
export const TERMS_LOADED_SUCCESSFULLY = "TERMS_LOADED_SUCCESSFULLY";
